module.exports = __webpack_public_path__ + "static/img/129.38195cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/129.png
// module id = i4pS
// module chunks = 0